import {
  GET_CORRESPONDENT,
  GET_CORRESPONDENT_FAILURE,
  GET_CORRESPONDENT_SUCCESS,
} from '../actions'
import { Correspondent, CorrespondentState } from '../types'
import { INITIAL_CORRESPONDENT_STATE } from '../containers/contexts/search'

export const correspondentReducer = (
  state: CorrespondentState = INITIAL_CORRESPONDENT_STATE,
  action: { type: string; correspondent?: Correspondent }
) => {
  const { type, correspondent } = action
  switch (type) {
    case GET_CORRESPONDENT:
      return { ...state, ...INITIAL_CORRESPONDENT_STATE, loadingResult: true }
    case GET_CORRESPONDENT_SUCCESS:
      return { ...state, correspondent, loadingResult: false }
    case GET_CORRESPONDENT_FAILURE:
      return { ...state, ...INITIAL_CORRESPONDENT_STATE, loadingResult: false }
    default:
      return state
  }
}
